/* ============================================================================
   nuud US — product gallery
   ----------------------------------------------------------------------------
   Thumbnail selection for the buy-box media column.

   Slot 0 is the pack shot and is owned by buy-box.js, which swaps it when the
   pack changes. Slots 1..n are the shared media blocks — the same cream
   whichever box it ships in — and are what these thumbs switch between.
   ========================================================================= */
(function () {
  'use strict';

  function init(gallery) {
    var main   = gallery.querySelector('[data-gallery-main]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!thumbs.length) return;

    function show(index) {
      // Slot 0 is the pack shot; anything else is a media slide.
      if (main) main.hidden = index !== 0;

      slides.forEach(function (slide) {
        var i = parseInt(slide.getAttribute('data-gallery-slide'), 10);
        var on = i === index;
        slide.hidden = !on;

        var video = slide.querySelector('video');
        if (video) {
          if (on) {
            var play = video.play();
            if (play && play.catch) play.catch(function () { /* autoplay refused */ });
          } else if (!video.paused) {
            video.pause();
          }
        }
      });

      thumbs.forEach(function (thumb) {
        var on = parseInt(thumb.getAttribute('data-gallery-thumb'), 10) === index;
        thumb.classList.toggle('is-selected', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(parseInt(thumb.getAttribute('data-gallery-thumb'), 10));
      });
    });

    // buy-box.js fires this when the pack changes.
    gallery.addEventListener('gallery:reset', function () { show(0); });

    show(0);
  }

  function boot() {
    document.querySelectorAll('[data-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
